import { useEffect } from "react";

export default function SeoJsonLd({ id, data }) {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, data]);
  return null;
}
